(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.FullPageHandler = (function(superClass) {
    extend(FullPageHandler, superClass);

    function FullPageHandler(name, opts) {
      FullPageHandler.__super__.constructor.call(this, name, opts);
      this.refreshNavHandler = false;
      this.draggable = false;
      this.resizable = false;
      this.startPosition = null;
      this.slideUpForm = false;
      this.modalOptions = {
        keyboard: false
      };
      this.destroyOnSave = false;
    }

    FullPageHandler.prototype.createDialog = function(loadOpts) {
      if (loadOpts == null) {
        loadOpts = {};
      }
      FullPageHandler.__super__.createDialog.call(this, loadOpts);
      this.dialog.on('shown', (function(_this) {
        return function(e) {
          var modal, parent;
          modal = _this.dialog.find('.modal-body');
          parent = modal.parents('div');
          modal.resizr({
            parent_selector: parent
          });
          return _this._handleResize();
        };
      })(this));
      this.dialog.addClass('fullpage_dialog');
      if (this.useMessageWriter) {
        return this.dialog.find('.message_writer').addClass('absolute-errorDiv');
      }
    };

    FullPageHandler.prototype.openDialog = function() {
      var ref;
      FullPageHandler.__super__.openDialog.call(this);
      this.dialog.find('.modal-body').resizr();
      if (this.useMessageWriter) {
        this.dialog.find('.message_writer').addClass('absolute-errorDiv');
        if (this.dialog.find('.message_writer').message_writer().length !== 0) {
          this.dialog.find('.message_writer').message_writer('setInitialClass');
        }
      }
      $(window).smartresize((function(_this) {
        return function() {
          return _this._handleResize();
        };
      })(this));
      return (ref = App.map) != null ? ref.on('resize', (function(_this) {
        return function() {
          return _this._handleResize();
        };
      })(this)) : void 0;
    };

    FullPageHandler.prototype._handleResize = function() {
      var height, left, ref, sidebarLeftOffset, sidebarWidth, top, topbuffer, width;
      top = $('#primary_header').outerHeight();
      left = App.sidebar.element.outerWidth(true);
      sidebarWidth = App.sidebar.element.outerWidth(true);
      sidebarLeftOffset = App.sidebar.element.offset().left;
      left = sidebarWidth + sidebarLeftOffset;
      topbuffer = (ref = typeof this.topBuffer === "function" ? this.topBuffer() : void 0) != null ? ref : -1;
      height = $(window).height() - top;
      width = $(window).width() - left;
      this.dialog.css({
        left: '-1px',
        top: topbuffer + 'px',
        marginLeft: left + 'px',
        marginTop: top + 'px',
        height: height + 'px',
        width: width + 'px'
      });
      this.dialog.find('.modal-body').resizr();
      return $(window).trigger('modal_resized');
    };

    return FullPageHandler;

  })(DialogHandler);

}).call(this);
